import React, { useState } from "react";
import Box from "../../../elements/box/Box";
import {
  AnnotationIcon,
  CalendarIcon,
  DocumentIcon,
} from "@heroicons/react/outline";
import ChatBox from "../../../parts/chat-box/ChatBox";
import { CSSTransition } from "react-transition-group";
import axiosAPI from "../../../utils/axios-api";
import { Link } from "react-router-dom";
import swal from "sweetalert2";

const API = process.env.REACT_APP_API;
function PartisipasiBox(props) {
  const [showChat, setShowChat] = useState(false);

  const {
    id,
    kuesioner_id,
    judul,
    nama,
    nama_institusi,
    keterangan,
    tanggal_buka,
    tanggal_tutup,
    status,
    status_jawaban,
    scoin,
    poin,
    partisipasi_pd,
    partisipasi_pu,
    tipe,
    user_group,
    tanggal_approval,
    sifat,
    sr,
  } = props.data ?? null;

  function renderPU(params) {
    if (partisipasi_pu === "menunggu") {
      return (
        <>
          <button
            onClick={() => kirimPersetujuan({ status: 1, id: id })}
            className="py-1 mr-1 my-2 px-4 rounded-full bg-blue-500 text-white dark:text-white text-sm"
          >
            Terima
          </button>
          <button
            onClick={() => kirimPersetujuan({ status: 0, id: id })}
            className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm"
          >
            Tolak
          </button>
        </>
      );
    } else if (partisipasi_pu === "diterima") {
      return (
        <button className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-green-500 text-green-600 dark:text-white text-sm">
          Diterima
        </button>
      );
    } else {
      return (
        <button className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-green-500 text-green-600 dark:text-white text-sm">
          -
        </button>
      );
    }
  }

  function renderPD(params) {
    if (partisipasi_pd === "diterima") {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
          Diterima
        </span>
      );
    } else if (partisipasi_pd === "ditolak") {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-red-500 text-red-600 dark:text-white text-sm">
          Ditolak
        </span>
      );
    } else if (partisipasi_pd === "menunggu") {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-red-500 text-red-600 dark:text-white text-sm">
          Menunggu
        </span>
      );
    } else {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
          -
        </span>
      );
    }
  }

  function renderSR(params) {
    if (sr === 1) {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
          OK
        </span>
      );
    } else {
      return (
        <span className="py-1 my-2 px-4 rounded-full bg-white dark:bg-gray-800 border border-blue-500 text-blue-600 dark:text-white text-sm">
          -
        </span>
      );
    }
  }

  function renderButtonIsi(params) {
    if (partisipasi_pu === "menunggu" && status_jawaban === 0) {
      return (
        <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-gray-300 text-white">
          <p className="text-xs">--</p>
        </button>
      );
    } else if (
      status_jawaban === 0 &&
      partisipasi_pd !== "menunggu" &&
      partisipasi_pd !== "ditolak"
    ) {
      return (
        <Link to={`/isi-kuesioner/${id}`}>
          <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white">
            <p className="text-xs">Isi Kuesioner</p>
          </button>
        </Link>
      );
    } else if (partisipasi_pu === "--" && partisipasi_pd === "diterima") {
      return (
        <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-gray-300 text-white">
          <p className="text-xs">Sudah di isi</p>
        </button>
      );
    } else if (status_jawaban === 1) {
      return (
        <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-gray-300 text-white">
          <p className="text-xs">Sudah di isi</p>
        </button>
      );
    }
  }

  function kirimPersetujuan(params) {
    let bodyPersetujuan = { status: params.status };
    if( params.status == 0 ){
      let body = {responden_id: id, kuesioner_id: kuesioner_id, status: "gagal"}
    
      axiosAPI
        .post(API + "scoin/konfirmasi", body)
        .then((res) => {
          axiosAPI
            .post(API + "responden/" + params.id + "/persetujuan-undangan", bodyPersetujuan)
            .then((res) => {
              props.onRefresh();
            });
        })
        .catch((xhr) => {
          console.log(xhr)
        });
    }else{
      axiosAPI
      .post(API + "responden/" + params.id + "/persetujuan-undangan", bodyPersetujuan)
      .then((res) => {
        props.onRefresh();
      });
    }
  }
  return (
    <div className="flex flex-row gap-4">
      <Box>
        <div className="flex flex-col">
          <div className="flex flex-row">
            <div className="w-10/12">
              <div className="flex flex-row items-center">
                <div className="flex-1 flex flex-col">
                  <h1 className="text-2xl font-bold">{judul}</h1>
                  <div className="flex flex-row gap-8 items-center mt-4">
                    <div className="flex flex-row gap-2 items-center">
                      <DocumentIcon className="h-4 w-4 text-blue-500" />
                      <p className="text-sm text-blue-500">{kuesioner_id}</p>
                    </div>

                    <div className="flex flex-row gap-2 items-center">
                      <CalendarIcon className="h-4 w-4 text-blue-500" />
                      <p className="text-sm text-blue-500">
                        {tanggal_buka.replace(/-/g, "/")}
                      </p>
                      <p>-</p>
                      <p className="text-sm text-blue-500">
                        {tanggal_tutup.replace(/-/g, "/")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex py-6 flex-col">
                <h1 className="text-lg font-semibold">
                  Pemilik <span className="font-normal">{nama}</span>
                </h1>
                <h1 className="text-lg font-semibold">
                  Institusi{" "}
                  <span className="font-normal">{nama_institusi ?? "-"}</span>
                </h1>
                {/* <p className="text-xs mt-6">
                  {keterangan.substr(0, 80)}
                </p> */}
              </div>
            </div>
            <div className="w-2/12 flex flex-col items-end gap-2">
              {/* <button onClick={() => setShowChat(!showChat)}>
                <AnnotationIcon className="h-8 w-8" />
              </button> */}
              <span className="py-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 font-bold text-sm">
                {poin} Poin
              </span>
              <span className="py-2 px-4 rounded bg-yellow-100 dark:bg-yellow-100 text-yellow-600 dark:text-yellow-900 font-bold text-sm">
                {scoin} Scoin
              </span>
            </div>
          </div>
          <div className="flex flex-col">
            {/* <div className="flex flex-row items-center">
              <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                Terbuka
              </span>
              <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                Likert
              </span>
              <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                Panduan
              </span>
              <span className="py-2 px-4 rounded bg-yellow-100 dark:bg-yellow-100 my-2 text-yellow-600 dark:text-yellow-900 font-bold text-sm">
                50000
              </span>
            </div> */}

            <div className="flex flex-row justify-between">
              <div className="flex flex-row gap-2">
                <div className="flex flex-col items-center gap-2 px-4 bg-gray-200 dark:bg-gray-700 py-2 rounded">
                  <p className="text-sm">Persetujuan Undangan</p>
                  <div className="flex flex-row justify-between">
                    {renderPU()}
                  </div>
                </div>

                <div className="flex flex-col items-center gap-2 bg-gray-200 dark:bg-gray-700 px-4 py-2 rounded">
                  <p className="text-sm">PD</p>
                  {renderPD()}
                </div>
                <div className="flex flex-col items-center gap-2 bg-gray-200 dark:bg-gray-700 px-4 py-2 rounded">
                  <p className="text-sm">SR</p>
                  {renderSR()}
                </div>
              </div>

              <div>
                <div className="flex flex-row gap-2 items-end">
                  {renderButtonIsi()}
                  
                  <button
                    onClick={() => setShowChat(!showChat)}
                    className="justify-center px-4 py-2 flex flex-row items-center rounded-lg border border-blue-500 text-blue-500"
                  >
                    <p className="text-xs">Chat</p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>
      {showChat ? (
        <CSSTransition
          in={showChat}
          timeout={200}
          classNames="anm-partisipasi-chat"
        >
          <div
            className="my-4 shadow-xl flex rounded-lg border border-gray-300 dark:border-gray-700 overflow-hidden"
            style={{ minWidth: "500px" }}
          >
            <ChatBox id={id} type="partisipasi" />
          </div>
        </CSSTransition>
      ) : null}
    </div>
  );
}

PartisipasiBox.propTypes = {};

export default PartisipasiBox;
